import React from 'react'
import dayjs from 'dayjs'
import { Card, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react'

import { PRIVATE_ROUTES } from '../../../routes'
import { camelCaseToWordConverter } from '../../../utils/commonUtils'
import styles from './JobCards.module.css'

const { Text } = Typography

const JobCards = ({ job }) => {
    const navigate = useNavigate()
    const isArchived = Boolean(job?.isArchived)
    const statusLabel = job?.status
        ? camelCaseToWordConverter(job.status)
        : 'N/A'
    const title = `${job?.title || 'Untitled Job'}${
        job?.noOfPositions ? ` (${job.noOfPositions})` : ''
    }`

    return (
        <Card
            className={`${styles.jobCard} ${
                isArchived ? styles.jobCardArchived : ''
            }`}
            hoverable={false}
            onClick={() => navigate(PRIVATE_ROUTES.jobApplication(job?._id))}
        >
            {isArchived ? (
                <span className={styles.archivedBadge}>Archived</span>
            ) : null}

            <div className={styles.cardContent}>
                <div className={styles.cardTop}>
                    <div className={styles.jobIconWrap}>
                        <Icon
                            icon="mdi:briefcase-outline"
                            width={22}
                            height={22}
                        />
                    </div>
                    <div className={styles.jobInfo}>
                        <Text className={styles.jobTitle} title={title}>
                            {title}
                        </Text>
                        <Text
                            className={styles.jobLocation}
                            title={
                                job?.location || 'Location not specified'
                            }
                        >
                            {job?.location || 'Location not specified'}
                        </Text>
                    </div>
                </div>

                <div className={styles.detailsSection}>
                    <div className={styles.metaRow}>
                        <div className={styles.metaBlock}>
                            <div className={styles.metaHeader}>
                                <Icon
                                    icon="mdi:calendar-outline"
                                    className={styles.metaIcon}
                                />
                                <span className={styles.metaLabel}>
                                    Created
                                </span>
                            </div>
                            <Text className={styles.metaValue}>
                                {job?.createdAt
                                    ? dayjs(job.createdAt).format(
                                          'DD MMM YYYY'
                                      )
                                    : 'N/A'}
                            </Text>
                        </div>
                        <div className={styles.metaBlock}>
                            <div className={styles.metaHeader}>
                                <Icon
                                    icon="mdi:progress-check"
                                    className={styles.metaIcon}
                                />
                                <span className={styles.metaLabel}>
                                    Status
                                </span>
                            </div>
                            <div className={styles.statusRow}>
                                <Text
                                    className={styles.metaValue}
                                    title={statusLabel}
                                >
                                    {statusLabel}
                                </Text>
                                <span
                                    className={
                                        job?.isActiveJob
                                            ? styles.statusActive
                                            : styles.statusInactive
                                    }
                                >
                                    {job?.isActiveJob
                                        ? 'Active'
                                        : 'Inactive'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.statsSection}>
                    <span className={styles.statMatches}>
                        {job?.matches || 0} Matches
                    </span>
                    <span className={styles.statApplied}>
                        {job?.applied || 0} Applied
                    </span>
                    <span className={styles.statHired}>
                        {job?.hired || 0} Hired
                    </span>
                </div>
            </div>
        </Card>
    )
}

export default JobCards
